var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "loginContainer" }, [
    _c("div", { staticClass: "loginInner" }, [
      _c("div", { staticClass: "login_header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("h2", { staticClass: "login_logo" }, [
          _vm._v("欢迎登录" + _vm._s(_vm.title))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "login_content" }, [
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.login($event)
              }
            }
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isMessage,
                    expression: "isMessage"
                  }
                ]
              },
              [
                _c("section", { staticClass: "login_message" }, [
                  _c("span", { staticClass: "prefix" }, [_vm._v("+86")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.phone,
                        expression: "phone"
                      }
                    ],
                    staticClass: "phone",
                    attrs: {
                      type: "tel",
                      maxlength: "11",
                      name: "phone",
                      placeholder: "请输入手机号"
                    },
                    domProps: { value: _vm.phone },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.phone = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "login_verification" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.code,
                        expression: "code"
                      }
                    ],
                    attrs: {
                      type: "tel",
                      maxlength: "8",
                      placeholder: "请输入验证码"
                    },
                    domProps: { value: _vm.code },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.code = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "get_verification",
                      class: { is_phone: _vm.isPhone },
                      attrs: { disabled: !_vm.isPhone },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.getCode($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.computeTime > 0
                              ? "已发送(" + _vm.computeTime + "s)"
                              : "获取验证码"
                          )
                      )
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "login_submit",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.RegisterTest($event)
                  }
                }
              },
              [_vm._v("注册")]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm._m(1)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login_logo" }, [
      _c("img", {
        staticClass: "logoImg",
        attrs: { src: require("./images/96_1.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "go_back", attrs: { href: "javascript:" } }, [
      _c("i", { staticClass: "iconfont icon-jiantou2" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-461aa466", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-461aa466","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login/Register.vue
// module id = null
// module chunks = 